import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined;

if (!url || !publishableKey) {
  // La publishable key es pública por diseño; la frontera de seguridad es RLS (docs/05 §0).
  // Sin config la app arranca pero avisa — evita builds rotos por entorno.
  console.warn('Tanteo: faltan VITE_SUPABASE_URL / VITE_SUPABASE_PUBLISHABLE_KEY');
}

export const supabase = createClient(url ?? 'http://localhost:54321', publishableKey ?? 'sb_publishable_local', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storageKey: 'tanteo-auth',
  },
});
